import { render, staticRenderFns } from "./BundleList.vue?vue&type=template&id=93ba9ba8&scoped=true"
import script from "./BundleList.vue?vue&type=script&lang=js"
export * from "./BundleList.vue?vue&type=script&lang=js"
import style0 from "./BundleList.vue?vue&type=style&index=0&id=93ba9ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ba9ba8",
  null
  
)

export default component.exports